<template>
  <ui-table :columns="columns" :rows="rows" :row-key="(row) => row.key" :row-class="rowClass" :end-label="$t('actions')" @open="(row) => $emit('open', row)">
    <template #cell-name="{ row }">
      <div class="ui-who">
        <ui-avatar :text="initialsOf(row.name)" :tone="row.hasContract ? 'accent' : 'neutral'" />
        <div :title="restaurantLabel(row.name)">
          <b>{{ restaurantLabel(row.name) }}</b>
          <small>#{{ row.restaurantId }}</small>
        </div>
      </div>
    </template>

    <template #cell-status="{ row }">
      <ui-chip :tone="kindTone(row.kind)" dot>{{ statusText(row) }}</ui-chip>
      <small v-if="row.kind === 'expired'" class="cs-billing">{{ $t("still_being_billed") }}</small>
    </template>

    <template #cell-contract="{ row }">
      <template v-if="row.hasContract">
        <b class="nw">{{ row.contractNumber || "—" }}</b>
        <small v-if="periodText(row.from, row.to)" class="ui-num">{{ periodText(row.from, row.to) }}</small>
        <small v-if="row.contractDate" class="ui-num">{{ $t("contract_date") }}: {{ localeDate(row.contractDate) }}</small>
      </template>
      <span v-else class="ui-muted">—</span>
    </template>

    <template #cell-services="{ row }">
      <template v-if="row.hasContract && row.services !== null">
        <span class="ui-num">{{ row.services }}</span>
        <small v-if="row.opis">{{ $t("contract_commission_prefix") }} {{ toLatin(row.opis) }}</small>
      </template>
      <span v-else class="ui-muted">—</span>
    </template>

    <template #end="{ row }">
      <ui-button v-if="!row.hasContract" size="sm" variant="primary" @click.stop="$emit('create', row)">{{ $t("new_contract") }}</ui-button>
      <ui-button v-else-if="row.kind === 'expired' || row.kind === 'expiring'" size="sm" :variant="row.kind === 'expired' ? 'danger' : 'accent'" @click.stop="$emit('renew', row)">{{ $t("renew") }}</ui-button>
      <ui-button v-else size="sm" @click.stop="$emit('open', row)">{{ $t("open") }}</ui-button>
    </template>

    <template #card="{ row }">
      <ui-item :tone="cardTone(row.kind)" :active="row.restaurantId === activeId" @click="$emit('open', row)">
        <span class="ui-who">
          <ui-avatar :text="initialsOf(row.name)" :tone="row.hasContract ? 'accent' : 'neutral'" />
          <span>
            <b>{{ restaurantLabel(row.name) }}</b>
            <small>#{{ row.restaurantId }}<template v-if="row.contractNumber"> · {{ row.contractNumber }}</template></small>
          </span>
        </span>
        <span class="ui-item__tags">
          <ui-chip :tone="kindTone(row.kind)" dot>{{ statusText(row) }}</ui-chip>
        </span>
        <span v-if="row.kind === 'expired'" class="cs-billing">{{ $t("still_being_billed") }}</span>
        <span v-if="row.hasContract" class="ui-item__line">
          <span v-if="periodText(row.from, row.to)" class="ui-num">{{ periodText(row.from, row.to) }}</span>
          <span v-if="row.services !== null">{{ $t("contract_items", { count: row.services }) }}</span>
          <span v-if="row.opis">{{ $t("contract_commission_prefix") }} <b>{{ toLatin(row.opis) }}</b></span>
          <span v-if="row.contractDate" class="ui-num">{{ $t("contract_date") }}: {{ localeDate(row.contractDate) }}</span>
        </span>
      </ui-item>
      <div v-if="!row.hasContract || row.kind === 'expired' || row.kind === 'expiring'" class="ui-item-actions">
        <span></span>
        <ui-button v-if="!row.hasContract" size="sm" variant="primary" @click="$emit('create', row)">{{ $t("new_contract") }}</ui-button>
        <ui-button v-else size="sm" :variant="row.kind === 'expired' ? 'danger' : 'accent'" @click="$emit('renew', row)">{{ $t("renew") }}</ui-button>
      </div>
    </template>
  </ui-table>
</template>

<script>
import hasContractLabels from "../hasContractLabels";

/**
 * Pregled ugovora (UiTable): tabela na računaru, kartice na telefonu i užem ekranu. Red otvara panel restorana; dugme u redu je
 * "Obnovi" (istekao ili uskoro ističe: otvara formu novog ugovora koji zatvara stari), "Otvori" (važi) ili "Novi ugovor" (nema ugovora).
 */
export default {
  name: "ContractList",
  mixins: [hasContractLabels],
  props: {
    rows: { type: Array, required: true },
    activeId: { type: Number, default: 0 },
  },
  computed: {
    columns() {
      return [
        { key: "name", label: this.$t("restaurant") },
        { key: "status", label: this.$t("status") },
        { key: "contract", label: this.$t("contracts_shell.col.contract"), hide: "sm" },
        { key: "services", label: this.$t("contracts_shell.col.services"), hide: "md" },
      ];
    },
  },
  methods: {
    rowClass(row) {
      return {
        "is-on": row.restaurantId === this.activeId,
        "is-off": row.kind === "none",
        "cs-row--expired": row.kind === "expired",
        "cs-row--expiring": row.kind === "expiring",
      };
    },
  },
};
</script>
